import React, { Component } from "react";
import { connect } from "react-redux";
import { breadcrumbs } from "../../../../actions/appActions";
import { push } from "react-router-redux";
import { OfficialsActive } from "../../components/grids/OfficialGrid";
import Button from "../../../../components/form/Button";
import { noop } from "lodash";
import { isInternal } from "../../CroUtils";
import { Select } from "../../../../components/form/Select";
import * as moment from "moment";
import DatePicker from "../../../../components/form/DateTime/DateTime";
import { getFunctionaryNoticeTypes } from "../../CroActions";

const onRowClick =
  (push, url) =>
  ({ id }) =>
    push(`${url}/funkcionari/form/${id}`);

class OfficialSt extends Component {
  state = {
    statementType: "INGOING",
    from: new Date(),
    to: new Date(),
    loading: false,
    functionaryNoticeTypes: [],
  };

  dateFormat = "YYYY-MM-DD";
  to = new Date();
  from = new Date();
  statementType = "INGOING";
  query = {
    from: moment(this.from).format(this.dateFormat),
    to: moment(this.to).format(this.dateFormat),
    type: this.statementType,
  };

  async componentWillMount() {
    const { gridName, breadcrumbs, breadcrumbsItems, auth, dispatch } = this.props;

    breadcrumbs(breadcrumbsItems);
    let obj = JSON.parse(window.localStorage.getItem(gridName));
    if (obj) {
      this.query = obj;
      this.from = new Date(obj.from);
      this.to = new Date(obj.to);
      this.statementType = obj.type;
    }
    if (isInternal(auth)) {
      this.setState({ loading: true });
      const functionaryNoticeTypes = await getFunctionaryNoticeTypes(dispatch);
      this.setState({ functionaryNoticeTypes: functionaryNoticeTypes.items, loading: false });
    }
  }

  onKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.apply();
    }
  };

  setQueryToLocalStorage = () => {
    const { gridName } = this.props;
    window.localStorage.setItem(gridName, JSON.stringify(this.query));
  };

  apply = () => {
    this.setState({
      year: this.year,
      from: this.from,
      to: this.to,
      statementType: this.state.statementType,
    });
    this.query = {
      from: moment(this.from).format(this.dateFormat),
      to: moment(this.to).format(this.dateFormat),
      type: this.statementType,
    };
    this.setQueryToLocalStorage();
  };

  handleChange = (statementType) => {
    this.statementType = statementType;
    this.setState({
      year: this.year,
      from: this.from,
      to: this.to,
      statementType,
    });
    this.query = {
      from: moment(this.from).format(this.dateFormat),
      to: moment(this.to).format(this.dateFormat),
      type: statementType,
    };
    this.setQueryToLocalStorage();
  };

  onChangeFrom = (val) => {
    this.from = val;
    this.query = {
      from: moment(val).format(this.dateFormat),
      to: moment(this.state.to).format(this.dateFormat),
      type: this.state.statementType,
    };
  };

  onChangeTo = (val) => {
    this.to = val;
    this.query = {
      from: moment(this.state.from).format(this.dateFormat),
      to: moment(val).format(this.dateFormat),
      type: this.state.statementType,
    };
  };

  onCreateAppeal = (noticeTypeId, selected) => {  
    const { auth } = this.props;
    if(selected.length === 0) return;

    this.props.push((selected.length === 1) ?
      { pathname: `${auth.startUrl}/funkcionari/${selected[0]}/vyzva`, state: { noticeTypeId } } :
      { pathname: `${auth.startUrl}/funkcionari/hromadna-vyzva`,
        state: {
          officialsIds: selected,
          noticeTypeId: noticeTypeId
      }
    });
  }

  render() {
    const {
      url,
      push,
      auth,
      gridName,
      location: { pathname },
    } = this.props;
    const late = pathname.includes("pozdni");
    //const incomplete = pathname.includes('neuplni');
    return (this.state.loading ? (<></>) : 
      <div className="officialStPage">
        <div className="officialStFilters">
          <div className="officialStFilters__fields">
            <label className="officialStFilters__field">
              <span className="officialStFilters__label">Období od</span>
              <DatePicker
                name="from"
                onChange={this.onChangeFrom}
                onKeyDown={this.onKeyDown}
                value={this.from}
              />
            </label>
            <label className="officialStFilters__field">
              <span className="officialStFilters__label">Období do</span>
              <DatePicker
                name="to"
                onChange={this.onChangeTo}
                onKeyDown={this.onKeyDown}
                value={this.to}
              />
            </label>
            <label className="officialStFilters__field">
              <span className="officialStFilters__label">Druh oznámení</span>
              <Select
                value={this.statementType}
                onChange={this.handleChange}
                items={[
                  { id: "INGOING", label: "Vstupní oznámení" },
                  ...(!late ? [{ id: "ONGOING", label: "Průběžné oznámení" }] : []),
                  { id: "OUTGOING", label: "Výstupní oznámení" },
                  ...(!late ? [
                    { id: "POINT3", label: "Oznámení podle Čl. II bodu 3 přechodného ustanovení zákona" },
                    { id: "POINT4", label: "Oznámení podle Čl. II bodu 4 – příjmy za rok 2017" },
                  ] : []),
                ]}
              />
            </label>
            <Button type="button" label="Vyhledat" onClick={this.apply} />
          </div>
        </div>

        <OfficialsActive
          gridName={gridName}
          url={url}
          adding={false}
          onAdd={noop}
          onRowClick={onRowClick(push, auth.startUrl)}
          moreCheckboxFns={isInternal(auth)}
          moreCheckboxFnsItems={this.state.functionaryNoticeTypes.map((type) => ({ label: type.name, value: type.id, onClick: (selected) => { this.onCreateAppeal(type.id, selected) } })) }
          fnText={"Zaslat výzvu"}
          onCheckboxFn={noop}
          allowCheck={isInternal(auth)}
          query={this.query}
        />
      </div>
    );

  }
}

const commonConnect = (mapStateToProps) =>
  connect(mapStateToProps, { breadcrumbs, push })(OfficialSt);

export const OfficialLateSt = commonConnect((state, { auth }) => ({
  breadcrumbsItems: [
    { label: "Funkcionáři" },
    { label: "S opožděným oznámením" },
  ],
  url: `${auth.startUrl}/api/funkcionari/pozdni`,
  gridName: "officialsGrid_late",
}));

export const OfficialMissingSt = commonConnect((state, { auth }) => ({
  breadcrumbsItems: [
    { label: "Funkcionáři" },
    { label: "S chybějícím oznámením" },
  ],
  url: `${auth.startUrl}/api/funkcionari/chybejici`,
  gridName: "officialsGrid_missing",
}));

export const OfficialIncompleteSt = commonConnect((state, { auth }) => ({
  breadcrumbsItems: [
    { label: "Funkcionáři" },
    { label: "S neúplným oznámením" },
  ],
  url: `${auth.startUrl}/api/funkcionari/neuplne`,
  gridName: "officialsGrid_incomplete",
}));
